import { RoleEnum } from '@zeus/index'

/** L'apprenant a son espace ; tout autre rôle connecté vit dans le back-office. */
function isLearner(role?: string | null): boolean {
  return !role || role === RoleEnum.User
}

/**
 * « Mon compte » du bon espace : celui de l'apprenant n'est pas ouvert au
 * personnel, qui a le sien dans le back-office. Sans session (visiteur), le lien
 * apprenant mène à la connexion.
 */
export function accountPathOf(role?: string | null): string {
  return isLearner(role) ? '/account' : '/back-office/account'
}

/** Le centre d'aide du bon espace, pour la même raison. */
export function helpPathOf(role?: string | null): string {
  return isLearner(role) ? '/help' : '/back-office/help'
}
